define('taoQtiItem/qtiCreator/widgets/static/modalFeedback/states/states',[
    'taoQtiItem/qtiCreator/widgets/states/factory',
    'taoQtiItem/qtiCreator/widgets/static/states/states',
    'taoQtiItem/qtiCreator/widgets/static/modalFeedback/states/Sleep',
    'taoQtiItem/qtiCreator/widgets/static/modalFeedback/states/Active'
], function(factory, states){
    return factory.createBundle(states, arguments);
});
